import { LinearSuggestionsFallback } from '../LinearSuggestions/LinearSuggestions.Fallback';

export const SearchHistoryLoading = LinearSuggestionsFallback;
